import React from 'react'
import { Provider } from 'react-redux'
import { Switch, Route } from 'react-router'
import { ConnectedRouter } from 'react-router-redux'

import App from './App'
import ScrollToTop from '../components/ScrollToTop'

import { requireAuthentication } from '../components/AuthenticatedComponent'
import LoginAdminView from '../views/LoginAdminView'
import LoginCustomerView from '../views/LoginCustomerView'

//MAIN REDIRECTOR
import HomeView from '../views/HomeView'
import ScanQRView from '../views/ScanQRView'

//MTO VACWAY
import SoldOutView from '../views/SoldOutView'
import SoldOutTypeView from '../views/SoldOutTypeView'
import AccessibilityView from '../views/AccessibilityView'
import PaymentView from '../views/PaymentView'
import PhoneView from '../views/PhoneView'
import TicketView from '../views/TicketView'
import PaymentError from '../views/PaymentError'
import LockerSelectorView from '../views/LockerSelectorView'
import ZoneSelectorView from '../views/ZoneSelectorView'

//OTO VACWAY
import OTOSelectorView from '../views/OTOSelectorView'
import OTOAccessView from '../views/OTOAccessView'
import OTOOpenView from '../views/OTOOpenView'

//RENTAL VACWAY
import LockerSelectorRentalView from '../views/LockerSelectorRentalView'
import ZoneSelectorRentalView from '../views/ZoneSelectorRentalView'
import PhoneRentalView from '../views/PhoneRentalView'
import PaymentRentalView from '../views/PaymentRentalView'
import TicketRentalView from '../views/TicketRentalView'

//BAQUEIRA ONLY CUSTOM DESIGN
import PaymentBaqueiraView from '../views/PaymentBaqueiraView'
import PhoneBaqueiraView from '../views/PhoneBaqueiraView'
import TicketBaqueiraView from '../views/TicketBaqueiraView'
import LockerSelectorBaqueiraView from '../views/LockerSelectorBaqueiraView'
import ZoneSelectorBaqueiraView from '../views/ZoneSelectorBaqueiraView'
import PaymentBaqueiraError from '../views/PaymentBaqueiraError'

//TIME-BASED RENTAL
import TimeSelectorView from '../views/TimeSelectorView'
import ZoneSelectorTimeView from '../views/ZoneSelectorTimeView'
import LockerSelectorTimeView from '../views/LockerSelectorTimeView'
import PhoneTimeView from '../views/PhoneTimeView'
import PaymentTimeView from '../views/PaymentTimeView'
import PaymentTimeError from '../views/PaymentTimeError'
import TicketTimeView from '../views/TicketTimeView'
import TimeAccessView from '../views/TimeAccessView'
import TimeOpenView from '../views/TimeOpenView'
import ExtendTimeCallbackView from '../views/ExtendTimeCallbackView'

import 'bootstrap/dist/css/bootstrap.css';
import '../style.css'
import '../timeMode.css'
import i18n from "./../i18n";
import { withNamespaces } from 'react-i18next';

class Root extends React.Component {
  constructor(props) {
    super(props);
    this.spinnerObserver = null;
  }

  componentDidMount() {
    // Initialize CSS variables from localStorage on every page load
    const storedQrData = localStorage.getItem('qrData');
    if (storedQrData) {
      try {
        const qrData = JSON.parse(storedQrData);
        this.injectCSSVariables(qrData);
      } catch (e) {
        console.error('Failed to parse stored QR data:', e);
      }
    }
  }

  componentWillUnmount() {
    // Clean up observer when component unmounts
    if (this.spinnerObserver) {
      this.spinnerObserver.disconnect();
    }
  }

  updateSpinnerLogos(logoBase64) {
    const spinnerImages = document.querySelectorAll('.spinner img');
    spinnerImages.forEach(img => {
      if (img.src.includes('/images/logo.png') || img.alt === 'Logo') {
        img.src = logoBase64;
      }
    });
  }

  setupSpinnerObserver(logoBase64) {
    // Disconnect existing observer if any
    if (this.spinnerObserver) {
      this.spinnerObserver.disconnect();
    }

    // Update existing spinners immediately
    this.updateSpinnerLogos(logoBase64);

    // Set up MutationObserver to watch for dynamically added spinners
    this.spinnerObserver = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          // Check if the added node is a spinner or contains a spinner
          if (node.nodeType === Node.ELEMENT_NODE) {
            if (node.classList && node.classList.contains('spinner')) {
              const img = node.querySelector('img');
              if (img && (img.src.includes('/images/logo.png') || img.alt === 'Logo')) {
                img.src = logoBase64;
              }
            } else {
              // Check if spinner exists within the added node
              const spinners = node.querySelectorAll('.spinner img');
              spinners.forEach(img => {
                if (img.src.includes('/images/logo.png') || img.alt === 'Logo') {
                  img.src = logoBase64;
                }
              });
            }
          }
        });
      });
    });

    // Start observing the document body for changes
    this.spinnerObserver.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  injectCSSVariables(qr) {
    // Inject CSS custom properties for dynamic theming
    if (qr?.headerConfig) {
      const root = document.documentElement;
      const { primaryColor, secondaryColor, textPrimary, logoBase64, backgroundColor, backgroundImage, backgroundSmartphoneImage, buttonColor1, buttonColor2, buttonText, iconsColor } = qr.headerConfig;

      const btnColor1 = buttonColor1 || primaryColor || '#01315f';
      const btnColor2 = buttonColor2 || secondaryColor || '#067ddb';

      root.style.setProperty('--customer-primary', primaryColor || '#01315f');
      root.style.setProperty('--customer-secondary', secondaryColor || '#067ddb');
      root.style.setProperty('--customer-icons-color', iconsColor || primaryColor || '#01315f');
      root.style.setProperty('--customer-text-primary', textPrimary || '#01315f');
      root.style.setProperty('--customer-gradient',
        `linear-gradient(135deg, ${btnColor1}, ${btnColor2})`
      );
      root.style.setProperty('--customer-button-text', buttonText || '#ffffff');
      root.style.setProperty('--customer-btn-color1', btnColor1);
      root.style.setProperty('--customer-btn-color2', btnColor2);
      
      // Set background color (hex) for both mobile and desktop
      if (backgroundColor) {
        root.style.setProperty('--customer-background-color', backgroundColor);
      } else {
        root.style.setProperty('--customer-background-color', '#f3f3f3');
      }

      // Set background image for smartphone
      if (backgroundSmartphoneImage) {
        root.style.setProperty('--customer-background-smartphone', `url(${backgroundSmartphoneImage})`);
      } else {
        root.style.setProperty('--customer-background-smartphone', 'none');
      }

      // Set background image for desktop
      if (backgroundImage) {
        root.style.setProperty('--customer-background-image', `url(${backgroundImage})`);
      } else {
        root.style.setProperty('--customer-background-image', 'none');
      }

      // Set up observer for spinner logos
      if (logoBase64) {
        this.setupSpinnerObserver(logoBase64);
      }
    }
  }

  render() {
    return (
      <Provider store={this.props.store} i18n={i18n}>
        <ConnectedRouter history={this.props.history}>
            <ScrollToTop>
            <Switch>
              <Route exact path="/login/admin" component={LoginAdminView} />
              <Route exact path="/login" component={LoginCustomerView} />
              <Route exact path="/qrsale/:id" component={HomeView} />
              <Route exact path="/soldOut" component={SoldOutView} />
              <Route exact path="/zoneSelectorView/:id" component={ZoneSelectorView} />
              <Route exact path="/lockerSelectorView" component={LockerSelectorView} />
              <Route exact path="/accessibilityView" component={AccessibilityView} />
              <Route exact path="/soldOutType" component={SoldOutTypeView} />
              <Route exact path="/paymentView" component={PaymentView} />
              <Route exact path="/phoneView" component={PhoneView} />
              <Route exact path="/ticketView" component={TicketView} />
              <Route exact path="/paymentError" component={PaymentError} />

              <Route exact path="/otoSelectorView/:id" component={OTOSelectorView} />
              <Route exact path="/otoAccessView/:id" component={OTOAccessView} />
              <Route exact path="/otoOpenView/:id" component={OTOOpenView} />

              <Route exact path="/zoneSelectorRentalView/:id" component={ZoneSelectorRentalView} />
              <Route exact path="/lockerSelectorRentalView" component={LockerSelectorRentalView} />
              <Route path="/phoneRentalView" component={PhoneRentalView} />
              <Route path="/paymentRentalView" component={PaymentRentalView} />
              <Route path="/ticketRentalView" component={TicketRentalView} />

              <Route exact path="/zoneSelectorBaqueiraView/:id" component={ZoneSelectorBaqueiraView} />
              <Route exact path="/lockerSelectorBaqueiraView" component={LockerSelectorBaqueiraView} />
              <Route exact path="/paymentBaqueiraView" component={PaymentBaqueiraView} />
              <Route exact path="/phoneBaqueiraView" component={PhoneBaqueiraView} />
              <Route exact path="/ticketBaqueiraView" component={TicketBaqueiraView} />
              <Route exact path="/paymentBaqueiraError" component={PaymentBaqueiraError} />

              <Route exact path="/timeSelectorView/:id" component={TimeSelectorView} />
              <Route exact path="/zoneSelectorTimeView/:id" component={ZoneSelectorTimeView} />
              <Route exact path="/lockerSelectorTimeView" component={LockerSelectorTimeView} />
              <Route path="/phoneTimeView" component={PhoneTimeView} />
              <Route path="/paymentTimeView" component={PaymentTimeView} />
              <Route path="/ticketTimeView" component={TicketTimeView} />
              <Route exact path="/paymentTimeError" component={PaymentTimeError} />
              <Route exact path="/timeAccessView/:id" component={TimeAccessView} />
              <Route exact path="/timeOpenView/:id" component={TimeOpenView} />
              <Route path="/extendTimeCallbackView" component={ExtendTimeCallbackView} />

              <Route exact path="/" component={ScanQRView} />
              <Route path="/" component={requireAuthentication(App)} />
            </Switch>
            </ScrollToTop>
        </ConnectedRouter>
      </Provider>
    )
  }
}

export default withNamespaces()(Root)
